import React from 'react';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <h1 className="footer-brand">AGR Consultant & Engineers</h1>
        </div>
        <div className="footer-links">
          <div className="footer-section">
            <h3 className="footer-title">AGR Consultant & Engineers</h3>
            <p className="footer-desc">
              At AGR, we're your trusted partner for comprehensive electrical solutions. With a focus on excellence and reliability, we offer services ranging from ACB and VCB maintenance to electrical installation and panel design.
            </p>
          </div>
          <div className="footer-section">
            <h3 className="footer-title">Our Services</h3>
            <ul className="footer-list">
              <li>Air Circuit Breaker (ACB)</li>
              <li>Vaccume Circuit Breaker (VCB)</li>
              <li>MCCB (Molded Case Circuit Breaker)</li>
              <li>LT/HT Protection Relay</li>
              <li>LT/HT Electrical Panels</li>
            </ul>
          </div>
          <div className="footer-section">
            <h3 className="footer-title">Contact Details</h3>
            <ul className="footer-list">
              <li>4R-17, Gandhi Kuttir, Bhiwadi, Alwar, Rajastha - 301019</li>
              <li>agrconsultant98@gmail.com</li>
              <li>+91 9257112851</li>             
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          Copyright © 2025 AGR Consultant & Enginners. All Rights Reserved. Designed By Ravi
        </div>
      </div>
    </footer>
  );
}
export default Footer;
